<template>
<div>
  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <h2 class="block-title align-center">{{GraphData.ChartTitle[actualLanguage]}}</h2>

      <div v-if="flagDisplayNewGraph" class="col-xs-12">

        <div class="col-sm-12 col-lg-12">
          <div id="chart">
            <apexchart  :options="pieChartOptions" :series="pieChartDataSeries"></apexchart>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>
</template>


<script>

import Vue from 'vue'
import {mapState, mapActions, mapGetters} from 'vuex'

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)


export default {
  name: 'GraphApexTimeline',
  props: ['GraphData'],

  /* Structure of GraphData:
  GraphData = {
    ChartTitle : {FR:'Titre Francais',EN:'English title'},
    Labels : ['Label 1','Label 2',...],
    Data : [Data 1, Data 2, ...]
  }
  */

  data() {
    return {
      actualLanguage : "FR",
      sectionTitle: this.GraphData.ChartTitle,
      flagDisplayNewGraph : true,

      pieChartDataSeries: this.GraphData.Data,
      pieChartOptions:{
        chart:{
          type:'pie',
        },
        pie:{
          expandOnClick:true,
          customScale:0.4
          },
        dataLabels:{
          enabled:true,
          style:{fontSize:'16px'},
        },
        labels:this.GraphData.Labels
      },


    }
  },
  components: {

  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

  },

  mounted() {
    //this.pieChartDataSeries = this.GraphData.Data
    //this.pieChartOptions.labels=this.GraphData.Labels
    //this.sectionTitle = this.GraphData.ChartTitle

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// GraphApexPies.vue?929a2c04